import { useState } from 'react';
import '../src/assets/css/style.css';
import Routings from './routing';
import UserContext from './utils/contexts/User';

function App() {
  let [galleryTag, setGalleryTag] = useState({
    menu: null,
    menuTagArr: null,
  });

  return (
    <UserContext.Provider value={{ galleryTag, setGalleryTag }}>
      <Routings />
    </UserContext.Provider>
  );
}

export default App;
